module.exports = __webpack_public_path__ + "img/avatar-07-120x120.9185db97.png";